var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showModuloForm === false)?_c('div',[_c('MarketingModules')],1):_c('CarrosselListagem',{attrs:{"tipo-conteudo":"PRODUCT_CATEGORY","base-route":"/fornecedor/customizacao/vitrine-produto","carousel-type-variant":"type1"}})}
var staticRenderFns = []

export { render, staticRenderFns }